
const obtenerParametrosQuery = (query) => {
  let keyValuePairs = query.split(/[&?]/g);
  let params = {};
  for (let i = 0, n = keyValuePairs.length; i < n; ++i) {
    let m = keyValuePairs[i].match(/^([^=]+)(?:=([\s\S]*))?/);
    if (m) {
      let key = decodeURIComponent(m[1]);
      (params[key] || (params[key] = [])).push(decodeURIComponent(m[2]));
    }
  }
  return params;
}

export const retrieveQueryParams = () => {
  const queryParams = window.location.search.slice(1);

  if (queryParams) {
    const objetoQueryParameters = obtenerParametrosQuery(queryParams);
    return objetoQueryParameters;
  } else {
    // console.log("No existen query parameters en la url");
    return {};
  }
};
